import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Button } from '../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import {
  MagnifyingGlass, Funnel, CalendarBlank, SortAscending, SortDescending,
} from '@phosphor-icons/react';

const STATUS_OPTIONS = [
  { value: 'all', label: 'All Status' },
  { value: 'draft', label: 'Draft' },
  { value: 'pending_approval', label: 'Pending Approval' },
  { value: 'approved', label: 'Approved' },
  { value: 'rejected_approval', label: 'Rejected' },
  { value: 'submitted', label: 'Submitted' },
  { value: 'accepted', label: 'Accepted' },
  { value: 'failed', label: 'Failed' },
  { value: 'corrected', label: 'Corrected' },
];

const SORT_OPTIONS = [
  { value: 'updated_at', label: 'Last Updated' },
  { value: 'service_date', label: 'Service Date' },
  { value: 'patient_name', label: 'Client Name' },
  { value: 'employee_name', label: 'Staff Name' },
  { value: 'sandata_status', label: 'Status' },
];

export const EVVResolutionFilters = ({
  searchTerm, setSearchTerm, filterStatus, setFilterStatus,
  dateFrom, setDateFrom, dateTo, setDateTo,
  sortBy, setSortBy, sortOrder, toggleSortOrder,
  onClearFilters,
}) => (
  <Card className="border-slate-200">
    <CardContent className="pt-4 pb-4">
      <div className="flex flex-col gap-3">
        <div className="flex flex-col sm:flex-row gap-3 items-end">
          <div className="flex-1">
            <Label className="text-xs text-slate-500 mb-1 block">Search</Label>
            <div className="relative">
              <MagnifyingGlass size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              <Input
                placeholder="Search patient or employee name..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="pl-9"
                data-testid="resolution-search"
              />
            </div>
          </div>
          <div className="w-full sm:w-52">
            <Label className="text-xs text-slate-500 mb-1 block">Status</Label>
            <Select value={filterStatus} onValueChange={setFilterStatus}>
              <SelectTrigger data-testid="resolution-status-filter">
                <Funnel size={14} className="mr-1 text-slate-400" />
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {STATUS_OPTIONS.map((o) => (
                  <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 items-end">
          <div className="w-full sm:w-44">
            <Label className="text-xs text-slate-500 mb-1 block">Date From</Label>
            <div className="relative">
              <CalendarBlank size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              <Input type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} className="pl-9" data-testid="filter-date-from" />
            </div>
          </div>
          <div className="w-full sm:w-44">
            <Label className="text-xs text-slate-500 mb-1 block">Date To</Label>
            <div className="relative">
              <CalendarBlank size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              <Input type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} className="pl-9" data-testid="filter-date-to" />
            </div>
          </div>
          <div className="w-full sm:w-48">
            <Label className="text-xs text-slate-500 mb-1 block">Sort By</Label>
            <Select value={sortBy} onValueChange={setSortBy}>
              <SelectTrigger data-testid="sort-by-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                {SORT_OPTIONS.map((o) => (
                  <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <Button
            variant="outline" size="icon" onClick={toggleSortOrder}
            title={sortOrder === 'asc' ? 'Oldest first' : 'Newest first'}
            data-testid="sort-order-toggle"
          >
            {sortOrder === 'asc' ? <SortAscending size={18} /> : <SortDescending size={18} />}
          </Button>
          {(searchTerm || dateFrom || dateTo || filterStatus !== 'all') && (
            <Button variant="ghost" size="sm" onClick={onClearFilters} data-testid="clear-filters-btn">
              Clear filters
            </Button>
          )}
        </div>
      </div>
    </CardContent>
  </Card>
);
